import { createTheme } from '@mui/material/styles';

let theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#90a4ae',
      contrastText: 'rgba(255,255,255,1)',
    },
    secondary: {
      main: '#ffa726',
      contrastText: 'rgba(255,255,255,1)',
    },
  },
  typography: {
    fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif`,
  },  
});

export const SputnikTheme = createTheme(theme, {
  palette: {
    info: {
      main: theme.palette.secondary.main,
    },
  },
});

